import {JSX, ReactNode} from "react";

interface HeroContentProps {
    children?: ReactNode;
}

export function HeroContent({children}: HeroContentProps): JSX.Element {
    return <div className="hero__content">{children}</div>;
}
